import { translateUi } from '../../../i18n'

export const customerGroupLabel = (group, translate = translateUi) => {
  const type = group.groupType || group.customerGroupType
  if (type === 'DEFAULT' || String(group.id || group.customerGroupId) === '1') return translate('默认分组')
  if (type === 'REFERRAL') return `${group.rootUsername || group.customerGroupRootUsername || ''} · ${translate('推广分组')}`
  return group.name || group.customerGroupName || translate('默认分组')
}
